const startPage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        login: 'Sign in',
    },
    productDescription: 'Automation of the activities of committee members who make decisions.',
};

export default startPage;
